import styled from "styled-components";
import { darkModeColors, fonts } from "../../consts";
import { IconButtonStyled } from "../Buttons/styled";

export const DarkModeWrapper = styled.div`
  position: absolute;
  z-index: 100;

  bottom: 24px;
  left: 24px;

  ${IconButtonStyled} {
    width: 64px;
    height: 64px;
    border-radius: 50%;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    &:hover {
      background: ${(props) =>
        props?.theme?.darkMode ? "rgba(246, 244, 240, 0.1)" : "rgba(52, 48, 61, 0.1)"};
    }
  }

  &:focus:after,
  &:hover:after {
    content: attr(data-text);
    overflow: visible;

    width: max-content;

    position: absolute;
    left: 50px;
    bottom: 50px;
    ${(props) => props?.maxWidth && `width: ${props.maxWidth}`};
    max-width: inherit;
    z-index: 100;

    padding: 0 12px;
    border-radius: 4px;
    border: ${(props) => props?.theme?.darkMode && `1px solid rgba(110, 110, 116, 0.55)`};

    background: ${darkModeColors.RAISIN_100_WHITE};
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);

    font-family: ${fonts.PLUS_JAKARTA_SANS};
    font-weight: 400;
    font-size: 14px;
    line-height: 26px;
    color: ${darkModeColors.ISABELLINE_RAISIN_100};
  }
`;
